import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { NodeData } from "../ds/client_ds.js";
import {
  CustomerSearchCriteria,
  PageListBean,
  PostDatedCheckEntryBean,
  PostDatedCheckEntrySearchCriteria,
  ReasonBean,
  RestCustomerListRequest,
  RestEntityUnLockRequest,
  RestPageListBean,
  RestPostDatedCheckEntryBeanRequest,
  RestReadRequest,
} from "../ds/ds.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DatePickerComponent,
  InputTextbox,
  NumberFormatInputbox,
  ProgressBar,
  ReasonCaptureComponent,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
} from "../gui_components/Util.js";
import { PostDatedCheckLookupHandler } from "../lookup/PostDatedCheckLookupHandler.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { AccountReceivableService } from "../services/AccountReceivableService.js";
import { CustomerService } from "../services/CustomerService.js";
import { BaseNodeBar, BaseToolBar, ModuleToolBar } from "./BaseModule.js";

import { DEFAULT_CURRENCY_CODE, NEW_ENTRY } from "../ds/App_Constants.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { OpenInvoiceLookupHandler } from "../lookup/OpenInvoiceLookupHandler.js";
import { InvoiceService } from "../services/InvoiceService.js";
import { ModuleUtils } from "./ModuleUtils.js";
import { History, AlignStartVertical } from "lucide-react";
import {
  ApproveIcon,
  CancelIcon,
  UnApproveIcon,
} from "../gui_components/Icons.js";
import CustomTable from "../gui_components/CustomTable.js";
class PostDatedCheckEntry extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);

    this.state = {
      pageTitle: "Post Dated Check Entry ",

      pageList: new PageListBean(),
      checkData: new PostDatedCheckEntryBean(),
      criteria: new PostDatedCheckEntrySearchCriteria(),
      isLoading: false,

      isShowSaveButton: false,
      isShowClearErrorButton: false,
      isShowUnApproveButton: false,
      isShowApproveButton: false,
      isShowCancelButton: false,
      isEntryFormOpen: false,
      isListFormOpen: false,
      isHistoryFormOpen: false,
      error_list: [],

      nodeList: [],
      selectedNodeKey: "headerView",
      moduleOrderStatus: "",
      isShowNodes: false,
      checkEntryList: new Array(),
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      inventoryAdjustmentLookupHandler: null,
      isShowModuleSearchContainer: false,
      moduleKeyCode: "NEW",
      isResetView: true,
      order: "asc",
      sortField: "",
      isViewMode: false,
      isShowProgressBarPopup: false,
      selectedDocument: "",
      selectedList: new Array(),
      isSpecialViewMode: false,
      isViewMode: false,
      isMaintenanceMode: true,
      customerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCustomerList: false,
      cancelReasons: new Array(),

      reasonData: new ReasonBean(),
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      isShowCancelReasonPopup: false,
      isDisabledFields: false,
      isShowInvoiceLookup: false,
      openInvoiceLookupHandler: null,
    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  moduleCaption = "Post Dated Check Entry";
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    ModuleUtils.getPostDatedCheckEntryStatusList();
    this.initLookupHandlers();

    this.addNewEntry();
    this.fetchAttributesFromLocalStorage();
  }
  fetchAttributesFromLocalStorage = () => {
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };

    const cancelReasons = new Array();
    if (!isEmptyArray(attribute_cache.purchaseOrderCancelReasons))
      cancelReasons.push(...attribute_cache.purchaseOrderCancelReasons);
    this.state.cancelReasons = cancelReasons;
  };
  initLookupHandlers = () => {
    let postDatedCheckLookupHandler = new PostDatedCheckLookupHandler(
      this.companyCode,
      "PostDatedCheck",
    );
    this.setState({
      postDatedCheckLookupHandler: postDatedCheckLookupHandler,
    });
  };
  /* open InventoryAdjustment entry form*/
  openEntryForm = () => {
    this.closeAllNodeViews();
    this.getNodeList();
    this.setState({
      isListFormOpen: false,
      isEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearErrorButton: true,
      isShowNodes: true,
      isResetView: false,
      isShowModuleSearchContainer: true,
      isSpecialViewMode: false,
      isHistoryFormOpen: false,
      isShowInvoiceLookup: false,
    });
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        isListFormOpen: false,
        disabled: false,
        isDisabledFields: false,
      });
      if (this.state.isViewMode) {
        let pageTitle = this.moduleCaption + " - VIEW";
        this.setState({
          isDisabledFields: true,
          disabled: true,
          pageTitle: pageTitle,
        });
      }
    } else {
      this.setState({
        disabled: true,
        isDisabledFields: true,
      });
    }
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
    let moduleOrderStatus = this.state.moduleOrderStatus;
    let status = ModuleUtils.getPostDatedCheckEntryStatusCaption(
      this.state.checkData.status,
    );

    if (status !== undefined && status !== null) {
      moduleOrderStatus = status;
    }
    this.setState({ moduleOrderStatus: moduleOrderStatus });
    this.initModuleButtons();
  };
  initModuleButtons = () => {
    let checkData = this.state.checkData;
    if (
      checkData.status == LogicConstants.POST_DATED_CHECKENTRY_UNAPPROVE_STATUS
    ) {
      this.setState({
        isShowUnApproveButton: false,
        isShowCancelButton: true,
        isShowApproveButton: true,
        isShowSaveButton: true,
        isDisabledFields: false,
      });
    }
    if (
      checkData.status == LogicConstants.POST_DATED_CHECKENTRY_APPROVE_STATUS
    ) {
      this.setState({
        isShowUnApproveButton: true,
        isShowCancelButton: true,
        isShowApproveButton: false,
        isShowSaveButton: false,
        isDisabledFields: true,
      });
    }
    if (
      checkData.status == LogicConstants.POST_DATED_CHECKENTRY_CANCEL_STATUS
    ) {
      this.setState({
        isShowUnApproveButton: false,
        isShowCancelButton: false,
        isShowApproveButton: false,
        isShowSaveButton: false,
        isDisabledFields: true,
      });
    }
    if (checkData.isFetched) {
      if (
        checkData.status == LogicConstants.POST_DATED_CHECKENTRY_OPEN_STATUS
      ) {
        this.setState({
          isShowUnApproveButton: false,
          isShowCancelButton: true,
          isShowApproveButton: true,
          isShowSaveButton: true,
          isDisabledFields: false,
        });
      }
    } else {
      if (
        checkData.status == LogicConstants.POST_DATED_CHECKENTRY_OPEN_STATUS
      ) {
        this.setState({
          isShowUnApproveButton: false,
          isShowCancelButton: false,
          isShowApproveButton: true,
          isShowSaveButton: true,
          isDisabledFields: false,
        });
      }
    }
  };
  /* close InventoryAdjustment entry form*/
  closeEntryForm = () => {
    let pageTitle = this.moduleCaption;
    this.setState({
      isListFormOpen: true,
      isEntryFormOpen: false,

      isShowSaveButton: false,
      isShowPDFReportButton: false,
      isShowExcelButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isResetView: false,
      isMaintenanceMode: false,
      isHistoryFormOpen: false,
      isViewMode: false,
      isSpecialViewMode: false,
      isDisabledFields: false,
      isShowInvoiceLookup: false,
    });
  };
  getEmptyView() {
    return <div></div>;
  }
  getNodeList = () => {
    let nodeList = [];
    let headerObject = this.getEmptyView();
    let headerNode = new NodeData(
      "headerView",
      "Header",
      headerObject,
      <AlignStartVertical size={16} />,
    );
    let historyNode = new NodeData(
      "historyView",
      "History",
      headerObject,
      <History size={16} />,
    );
    let checkData = this.state.checkData;
    nodeList["headerView"] = headerNode;
    // if (checkData.isFetched)
    nodeList["historyView"] = historyNode;
    this.setState({ nodeList: nodeList });
  };

  nodeOnSelect = (selectedNode) => {
    if (selectedNode == "headerView") {
      this.setCheckEntryHeaderView();
    } else if (selectedNode == "historyView") {
      this.setCheckEntryHistoryView();
    }
    this.setState({ selectedNodeKey: selectedNode });
  };

  setCheckEntryHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isEntryFormOpen: true,
      isListFormOpen: false,
      isHistoryFormOpen: false,
    });
  };
  setCheckEntryHistoryView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: false,
      isEntryFormOpen: false,
      isListFormOpen: false,
      isHistoryFormOpen: true,
    });
  };
  closeAllNodeViews = () => {
    this.setState({
      isEntryFormOpen: false,
      isListFormOpen: false,
      isHistoryFormOpen: false,
    });
  };
  getListResponse = (response) => {
    let checkEntryList = new Array();
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.postDatedCheckPageList) &&
      !isEmptyArray(response.data.postDatedCheckPageList.postDatedChecks)
    ) {
      checkEntryList = response.data.postDatedCheckPageList.postDatedChecks;
      this.state.pageList.totalCount =
        response.data.postDatedCheckPageList.totalCount;
      this.state.pageList.currentPage =
        response.data.postDatedCheckPageList.currentPage;
    }
    this.setState({
      checkEntryList: checkEntryList,
      isLoading: false,
      loadingText: "",
    });
  };
  loadPostDatedCheckEntryPage = () => {
    let request = new RestPostDatedCheckEntryBeanRequest();
    request.companyCode = this.companyCode;
    request.pageInput = this.state.pageList;
    const criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    request.criteria = criteria;
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
    });
    if (SecurityAccessManager.PostDatedCheckEntryMaintenance_IsAccessible()) {
      AccountReceivableService.getPostDatedCheckEntryPageList(
        request,
        this.getListResponse,
        this.errorCallBack,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isLoading: true,
    });
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };
  filterCheckEntry = () => {
    this.loadPage(1);
  };
  resetfilteredCheckEntry = (criteria) => {
    criteria = new PostDatedCheckEntrySearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
    // criteria.postDatedCheckEntryNumber = "";
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  searchOnChange = (e) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria["postDatedCheckEntryNumber"] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadPage = (pageNumber) => {
    let pageList = this.state.pageList;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadPostDatedCheckEntryPage();
  };
  addNewEntry = () => {
    let checkData = new PostDatedCheckEntryBean();
    checkData.companyCode = this.companyCode;
    checkData.code = NEW_ENTRY;
    checkData.currencyCode = DEFAULT_CURRENCY_CODE;
    checkData.status = LogicConstants.POST_DATED_CHECKENTRY_OPEN_STATUS;
    checkData.createdDate = new Date().toLocaleDateString("sv-SE");
    let pageTitle = this.moduleCaption + " - NEW";
    if (!isEmptyString(this.state.moduleKeyCode)) {
      checkData.code = this.state.moduleKeyCode;
      if (this.state.moduleKeyCode == NEW_ENTRY) {
        this.isLocked = false;
      } else {
        this.isLocked = true;
      }
    } else checkData.code = NEW_ENTRY;

    this.setState({
      checkData: checkData,
      pageTitle: pageTitle,
      selectedNodeKey: "headerView",
    });
    this.state.checkData = checkData;

    this.openEntryForm();
  };

  getModuleListView = () => {
    let checkData = this.state.checkData;
    if (checkData.code === NEW_ENTRY) {
      this.closeEntryForm();
      this.loadPage(1);
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode) this.unLockPostDatedCheck(checkData.code);
      } else {
        this.isLocked = false;
      }

      this.closeEntryForm();
      this.loadPage(1);
    }
  };

  resetView = () => {
    let _checkData = this.state.checkData;
    this.state.isReseted = true;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode) this.unLockPostDatedCheck(_checkData.code);
    } else {
      this.isLocked = false;
    }
    let checkData = new PostDatedCheckEntryBean();

    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.setState({
      isShowAlert: false,
      isResetModule: true,
      disabled: false,
      selectedNodeKey: "headerView",
      checkData: checkData,
      isShowInvoiceLookup: false,
    });
    this.hideAlertCallBack();

    this.clearError();
    this.addNewEntry();
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  moduleExit = () => {
    let checkData = this.state.checkData;
    if (checkData.code === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode) this.unLockPostDatedCheck(checkData.code);
      } else {
        this.isLocked = false;
      }

      this.props.onModuleExit();
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  selectButtonClick = (e) => {
    this.editPostCheckEntry(this.state.moduleKeyCode);
  };

  handleResponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handleApproveResponse = (response) => {
    let success = false;
    let infoMsg = "";
    let errMsg = "";
    let errList = [];
    if (!isEmpty(response.mainOperationResponse)) {
      if (!isEmptyArray(response.mainOperationResponse.errors)) {
        response.mainOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          ),
        );
        success = false;
      }
      if (!isEmptyArray(response.mainOperationResponse.infos)) {
        response.mainOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription),
        );
        success = true;
      }
    }
    if (!isEmpty(response.additionalOperationResponse)) {
      if (!isEmptyArray(response.additionalOperationResponse.errors)) {
        response.additionalOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          ),
        );
        success = false;
      }
      if (!isEmptyArray(response.additionalOperationResponse.infos)) {
        response.additionalOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription),
        );
        success = true;
      }
    }
    if (!isEmptyArray(errList) && errList.length > 0) success = false;
    if (!isEmptyString(infoMsg) && !isEmptyString(errMsg)) {
      let msg = infoMsg + errMsg;
      let successMsg = [];
      successMsg.push(msg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (!isEmptyString(infoMsg)) {
      let successMsg = [];
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (!isEmptyString(errMsg)) {
      let errorMsg = [];
      errorMsg.push(errMsg);
      this.setState({
        alertMessage: errorMsg,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({ error_list: errList });
    return success;
  };
  errorCallBack = (error) => {
    ShowError(error);
  };

  savePostDatedCheckEntryResponse = (response) => {
    this.handleResponse(response.data);
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.postDatedCheckEntry)
    ) {
      let checkData = response.data.postDatedCheckEntry;
      this.setState({ checkData: checkData });
      if (!this.isLocked) {
        this.editPostCheckEntry(checkData.code);
      } else {
        this.code = checkData.code;
        this.unLockPostDatedCheck(checkData.code);
      }
    }
  };
  savePostDatedCheckEntry = () => {
    this.setState({
      isLoading: true,
      loadingText: "Saving ..",
    });
    let checkData = this.state.checkData;
    checkData.companyCode = this.companyCode;

    if (checkData.isFetched) {
      if (SecurityAccessManager.PostDatedCheckEntryUpdation_IsAccessible()) {
        AccountReceivableService.updatePostDatedCheckEntry(
          checkData,
          this.savePostDatedCheckEntryResponse,
          this.errorCallBack,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (SecurityAccessManager.PostDatedCheckEntryCreation_IsAccessible()) {
        AccountReceivableService.createPostDatedCheckEntry(
          checkData,
          this.savePostDatedCheckEntryResponse,
          this.errorCallBack,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  validateData = (data) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (data == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(data.customerCode)) {
        let errMsg = "Customer is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.checkNumber)) {
        let errMsg = "CheckNumber is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.checkDate)) {
        let errMsg = "CheckDate is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (data.checkAmount <= 0) {
        let errMsg = "CheckAmount is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({ errorList: err_list });
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValid = true;
      this.setState({ isShowAlert: false });
    }
    return isValid;
  };
  save = () => {
    let checkData = this.state.checkData;
    let isValid = this.validateData(checkData);
    if (isValid) {
      this.savePostDatedCheckEntry();
    }
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ errorList: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readPostDatedCheckEntryResponse = (response) => {
    let errMsg = "";
    if (response.data.lockResponse != null) {
      if (!isEmpty(response.data.lockResponse.errors)) {
        this.showErrorMessage(response.data.lockResponse);
        this.state.isViewMode = true;
      }
    }
    if (response.data.postDatedCheckResponse != null) {
      if (response.data.postDatedCheckResponse.errors != null) {
        response.data.postDatedCheckResponse.errors.map((err) => {
          errMsg = err.messageDescription;
        });
      }
    }
    if (
      errMsg !=
      "PostDated Check Entry [" + this.state.moduleKeyCode + "] Not read!"
    ) {
      this.showErrorMessage(response.data.postDatedCheckResponse);
    }
    if (response.data.isSuccess == true) {
      this.setState({ isLoading: false, loadingText: "" });
      if (
        response.data.postDatedCheckResponse != null &&
        response.data.postDatedCheckResponse.postDatedCheckEntry != null
      ) {
        const checkData =
          response.data.postDatedCheckResponse.postDatedCheckEntry;
        let pageTitle = this.moduleCaption + " - VIEW";
        let moduleKeyCode = checkData.code;
        // this.clearError();
        this.state.checkData = checkData;

        this.setState({
          checkData: checkData,
          pageTitle: pageTitle,
          isShowNodes: true,
          moduleKeyCode: moduleKeyCode,
          isLoading: false,
          loadingText: "",
          selectedNodeKey: "headerView",
        }, () => {
            this.openEntryForm();
          });
        this.isLocked = true;
        this.getNodeList();
        // this.openEntryForm();
      } else {
        this.addNewEntry();
      }
    }
  };
  editPostCheckEntry = (code) => {
    const readrequest = new RestReadRequest();
    readrequest.code = code;
    readrequest.companyCode = this.companyCode;
    readrequest.isLoadChildren = true;
    let isLockRequired = NEW_ENTRY === code ? false : true;
    readrequest.isLockRequired = isLockRequired;
    if (SecurityAccessManager.PostDatedCheckEntryView_IsAccessible()) {
      AccountReceivableService.initPostDatedCheckEntryModule(
        readrequest,
        this.readPostDatedCheckEntryResponse,
        this.errorCallBack,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isLoading: true,
    });
  };
  readInvoiceResponse = (response) => {
    let checkData = this.state.checkData;
    if (!isEmpty(response.data) && !isEmpty(response.data.invoice)) {
      let invoiceData = response.data.invoice;
      checkData.invoiceNumber = invoiceData.code;
      checkData.customerPurchaseOrderNumber =
        invoiceData.customerPurchaseOrderNumber;
      this.setState({ checkData: checkData });
    }
  };
  readInvoice = (code) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    InvoiceService.readInvoice(
      readrestInput,
      this.readInvoiceResponse,
      this.errorCallBack,
    );
  };
  onChange = (e) => {
    let checkData = this.state.checkData;
    checkData[e.target.name] = e.target.value;
    if (e.target.name == "invoiceNumber") {
      this.readInvoice(e.target.value);
    }
    this.setState({ checkData: checkData });
  };
  /** customer autocomplete */
  customerOnChange = (e) => {
    let _customerCode = e.target.value;
    this.state.isShowAutoCompleteCustomerList = true;
    let checkData = this.state.checkData;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    if (isEmpty(_customerCode)) {
      this.state.isShowAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
      let checkData = this.state.checkData;
      checkData.customerCode = "";
      checkData.customerName = "";

      let suggestion = [];
      this.setState({
        isShowAutoCompleteCustomerList: showAutoCompleteList,
        checkData: checkData,
        customerPageListForAutoCompleteList: suggestion,
        isShowInvoiceLookup: false,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      _customerCode !== ""
    ) {
      setTimeout(() => {
        this.readCustomerCodeBySearchString(e.target.value);
      }, 200);
    }
    checkData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ checkData: checkData });
  };
  readCustomerCodeBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 10;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readCustomerBySearchCodeResponse,
      this.errorCallBack,
    );
  }
  readCustomerBySearchCodeResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.customerPageList) &&
      !isEmptyArray(response.data.customerPageList.customers)
    ) {
      let customerData = response.data.customerPageList.customers;
      let simpleAutoCompleteList = new Array();
      if (customerData.length > 0 && customerData != null) {
        customerData.map((customer) => {
          let simpleItemBean = {
            code: customer.code,
            description: customer.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        customerPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  customerEnterKeyEventHandler = (e) => {
    this.readCustomer(e.target.value);
    this.state.isShowAutoCompleteCustomerList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayAutoCustomerCompleteList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  clearError = () => {
    this.setState({ error_list: new Array() });
  };
  getOpenInvoiceResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.invoicePageList) &&
      !isEmptyArray(response.data.invoicePageList.invoices)
    ) {
      let checkData = this.state.checkData;
      let openInvoiceLookupHandler = new OpenInvoiceLookupHandler(
        this.companyCode,
        "Invoice",
        checkData.customerCode,
      );
      this.setState({
        openInvoiceLookupHandler: openInvoiceLookupHandler,
        isShowInvoiceLookup: true,
      });
    } else {
      this.setState({ isShowInvoiceLookup: false });
    }
  };
  getOpenInvoices = (code) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    InvoiceService.getOpenInvoicesForAccountReceivable(
      readrestInput,
      this.getOpenInvoiceResponse,
      this.errorCallBack,
    );
  };
  readCustomerResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.customer)) {
      let customerData = response.data.customer;
      let checkData = this.state.checkData;
      checkData.customerCode = customerData.code;
      checkData.customerName = customerData.description;
      this.setState({
        checkData: checkData,
      });

      this.getOpenInvoices(checkData.customerCode);
    }
  };
  readCustomer = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    CustomerService.readCustomerWithChildren(
      readrestInput,
      this.readCustomerResponse,
      this.errorCallBack,
    );
  };

  approveResponse = (response) => {
    // this.handleApproveResponse(response.data);
    let isSuccess = this.handleApproveResponse(response.data);
    if (isSuccess) {
      if (
        !isEmpty(response.data) &&
        !isEmpty(response.data.mainOperationResponse) &&
        !isEmpty(response.data.mainOperationResponse.postDatedCheckEntry)
      ) {
        const checkData =
          response.data.mainOperationResponse.postDatedCheckEntry;

        this.editPostCheckEntry(checkData.code);
      }
    }
    this.setState({ isLoading: false, loadingText: "" });
  };
  approveCheckEntry = () => {
    let checkData = this.state.checkData;
    let request = new RestPostDatedCheckEntryBeanRequest();
    request.postDatedCheckEntry = checkData;

    if (checkData.isFetched) {
      request.isLockRequired = true;
      if (
        SecurityAccessManager.PostDatedCheckEntryUpdation_IsAccessible() &&
        SecurityAccessManager.PostDatedCheckEntryApproval_IsAccessible()
      ) {
        AccountReceivableService.updateAndApprovePostDatedCheckEntry(
          request,
          this.approveResponse,
          this.errorCallBack,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      request.isLockRequired = false;
      if (
        SecurityAccessManager.PostDatedCheckEntryCreation_IsAccessible() &&
        SecurityAccessManager.PostDatedCheckEntryApproval_IsAccessible()
      ) {
        AccountReceivableService.createAndApprovePostDatedCheckEntry(
          request,
          this.approveResponse,
          this.errorCallBack,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  unlockResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editPostCheckEntry(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        // this.isLocked = false; optional
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };
  unLockPostDatedCheck = (code) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    if (SecurityAccessManager.PostDatedCheckEntryMaintenance_IsAccessible()) {
      AccountReceivableService.unLockPostDatedCheckEntryNumber(
        request,
        this.unlockResponse,
        this.errorCallBack,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  unApproveResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleResponse(response.data);
    if (
      !isEmpty(response) &&
      !isEmpty(response.data) &&
      !isEmpty(response.data.postDatedCheckEntry)
    ) {
      const checkData = response.data.postDatedCheckEntry;
      let pageTitle = this.moduleCaption + " - EDIT";
      this.setState({
        checkData: checkData,
        pageTitle: pageTitle,
      });
      if (this.isLocked) {
        this.code = checkData.code;
        this.unLockPostDatedCheck(checkData.code);
      }
    }
  };
  unApproveCheckEntry = () => {
    this.setState({
      isLoading: true,
      loadingText: "UnApproving InBound Order",
    });
    let checkData = this.state.checkData;
    if (SecurityAccessManager.PostDatedCheckEntryUnApproval_IsAccessible()) {
      AccountReceivableService.unApprovePostDatedCheckEntry(
        checkData,
        this.unApproveResponse,
        this.errorCallBack,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  openReasonCapture = (type) => {
    if (type === 1) {
      this.setState({
        isShowCancelReasonPopup: true,
      });
    }
    this.setState({
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
    });
  };
  closeReasonModelCallBack = () => {
    this.setState({
      isShowCancelReasonPopup: false,
      reasonData: new ReasonBean(),
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
    });
  };
  onReasonDescChange = (e) => {
    let reasonData = this.state.reasonData;
    reasonData[e.target.name] = e.target.value;
    this.setState({ reasonData: reasonData });
  };

  onReasonChange = (e) => {
    this.state.showAutoCompleteReasonList = true;
    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteReasonList;
    if (isEmpty(e.target.value)) {
      this.state.showAutoCompleteReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteReasonList: showAutoCompleteList,
        reasonData: reason,
        reasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && e.target.value !== "") {
      this.readReasonBySearchString(e.target.value);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.cancelReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteReasonList = false;
          let showAutoCompleteList = this.state.showAutoCompleteReasonList;
          this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
        }
      });
    }
    this.setState({ reasonData: reasonData });
  };
  readReasonBySearchString(searchString) {
    let reasonData = this.state.cancelReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(searchString.toLowerCase()) > -1,
    );
    this.setState({ reasonPageListForAutoCompleteList: filteredSuggestions });
  }
  reasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    reasonData["code"] = e.target.value;
    let reasonList = this.state.cancelReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        reasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteReasonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
  };
  cancelResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleResponse(response.data);
    if (
      !isEmpty(response) &&
      !isEmpty(response.data) &&
      !isEmpty(response.data.postDatedCheckEntry)
    ) {
      const checkData = response.data.postDatedCheckEntry;
      let pageTitle = this.moduleCaption + " - EDIT";
      this.setState({
        checkData: checkData,
        pageTitle: pageTitle,
      });
      if (this.isLocked) {
        this.code = checkData.code;
        this.unLockPostDatedCheck(checkData.code);
      }
    }
  };

  saveAndcancelCheckEntry = () => {
    this.setState({
      isLoading: true,
      loadingText: "Cancelling InBound Order",
    });
    const checkData = this.state.checkData;
    const request = new RestPostDatedCheckEntryBeanRequest();
    request.postDatedCheckEntry = checkData;
    request.specialReason = this.state.reasonData.code;
    request.isLockRequired = true;
    // request.
    if (SecurityAccessManager.PostDatedCheckEntryCancellation_IsAccessible()) {
      AccountReceivableService.cancelPostDatedCheckEntry(
        request,
        this.cancelResponse,
        this.errorCallBack,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isLoading: false,
        loadingText: "",
      });
    }
  };
  onCancelReasonContinue = () => {
    this.saveAndcancelCheckEntry();
    this.closeReasonModelCallBack();
  };
  cancelCheckEntry = (e) => {
    if (e.detail == 1) this.openReasonCapture(1);
  };
  getHeaderView() {
    return (
      <PostDatedCheckEntryForm
        {...this.state}
        onChange={this.onChange}
        customerOnChange={this.customerOnChange}
        customerEnterKeyEventHandler={this.customerEnterKeyEventHandler}
        displayAutoCustomerCompleteList={this.displayAutoCustomerCompleteList}
      />
    );
  }
  getHistoryView() {
    return <PostDatedCheckHistoryForm {...this.state} />;
  }
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let checkEntryList = this.state.checkEntryList;
    if (sortField && !isEmptyArray(checkEntryList)) {
      const sorted = [...checkEntryList].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ checkEntryList: sorted });
    }
  };
  render() {
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />

        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <ModuleToolBar
          isShowNewButton={false}
          onNewEntry={() => this.addNewEntry()}
          onModuleExit={() => this.moduleExit()}
          resetView={() => this.resetView()}
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          isMaintenanceMode={this.state.isMaintenanceMode}
          onModuleKeyContainerButtonClick={this.editPostCheckEntry}
          moduleKeyCode={this.state.moduleKeyCode}
          onModuleKeyCodeChange={this.onModuleKeyCodeChange}
          getModuleListView={this.getModuleListView}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.postDatedCheckLookupHandler} //for f2 lookup
          showCriteriaDialog={true} //for f2 lookup
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          disabled={this.state.disabled}
          selectButtonClick={this.selectButtonClick}
          isSpecialViewMode={this.state.isSpecialViewMode}
          isResetView={this.state.isResetView}
        />
        {!this.state.isListFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (
            <BaseToolBar
              save={this.save}
              clearError={this.clearError}
              isShowSaveButton={this.state.isShowSaveButton}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              pageTitle={this.state.pageTitle}
              isSpecialViewMode={this.state.isSpecialViewMode}
              extend_toolbar={
                <>
                  {this.state.isShowUnApproveButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.unApproveCheckEntry(e)}
                    >
                      <UnApproveIcon />
                      UnApprove
                    </Button>
                  )}
                  {this.state.isShowApproveButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.approveCheckEntry(e)}
                    >
                      <ApproveIcon />
                      Approve
                    </Button>
                  )}
                  {this.state.isShowCancelButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.cancelCheckEntry(e)}
                    >
                      <CancelIcon />
                      Cancel
                    </Button>
                  )}
                </>
              }
            />
          )}
        {this.state.isShowNodes && (
          <BaseNodeBar
            nodeList={this.state.nodeList}
            selectedModuleKey={this.state.selectedNodeKey}
            nodeOnSelect={this.nodeOnSelect}
            moduleStatus={this.state.moduleOrderStatus}
          />
        )}
        {!this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          this.state.isEntryFormOpen &&
          !this.state.isHistoryFormOpen &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          this.state.isEntryFormOpen &&
          !this.state.isHistoryFormOpen &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          !this.state.isEntryFormOpen &&
          this.state.isHistoryFormOpen &&
          this.getHistoryView()}
        {this.state.isListFormOpen && this.state.isSpecialViewMode == false && (
          <PostDatedCheckEntryListForm
            {...this.state}
            checkEntryList={this.state.checkEntryList}
            pageList={this.state.pageList}
            criteria={this.state.criteria}
            filterCheckEntry={this.filterCheckEntry}
            loadFirst={this.loadFirst}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
            loadLast={this.loadLast}
            editPostCheckEntry={this.editPostCheckEntry}
            resetfilteredCheckEntry={this.resetfilteredCheckEntry}
            isLoading={this.state.isLoading}
            searchOnChange={this.searchOnChange}
            handleSortingChange={this.handleSortingChange}
          />
        )}
        <ReasonCaptureComponent
          reasons={this.state.cancelReasons}
          reasonData={this.state.reasonData}
          title="Check Entry Cancel"
          onChange={this.onReasonChange}
          onClick={this.onCancelReasonContinue}
          isShowPopup={this.state.isShowCancelReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />
      </div>
    );
  }
}
class PostDatedCheckEntryListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.searchRef = React.createRef();
  }
  componentDidMount() {
    if (this.searchRef.current != null) {
      this.searchRef.current.focus();
    }
  }
  searchOnChange = (e) => {
    this.props.searchOnChange(e);
  };
  filterCheckEntry = (e) => {
    if (e.detail == 1) this.props.filterCheckEntry();
  };
  resetfilteredCheckEntry = (e) => {
    let criteria = this.props.criteria;
    if (e.detail == 1) this.props.resetfilteredCheckEntry(criteria);
  };
  loadFirst = (e) => {
    if (e.detail == 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail == 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail == 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail == 1) this.props.loadLast();
  };
  editPostCheckEntry = (e, val, rowData) => {
    if (e.detail == 1) this.props.editPostCheckEntry(val);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterCheckEntry();
    }
  };

  postDatedColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("PostDatedCheckEntry#", "code", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.editPostCheckEntry, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Check#", "checkNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CheckDate", "checkDate", true, false, true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CheckAmount", "checkAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CurrencyCode", "currencyCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "status", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setStatusDetails(true, this.getCaption),
    );

    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("Created Date", "createdDate", true, false, true)
    //     .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    // );

    return columns;
  };
  getCaption = (status) => {
    return ModuleUtils.getPostDatedCheckEntryStatusCaption(status);
  };
  render() {
    let checkEntryList = this.props.checkEntryList;
    let criteria = this.props.criteria;
    let pageList = this.props.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let isLoading = this.props.isLoading;
    return (
      <div>
        <div className="secondary_module_header">
          <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                ref={this.searchRef}
                name="postDatedCheckEntryNumber"
                type="text"
                value={criteria.postDatedCheckEntryNumber}
                placeholder="Enter Value to Filter.."
                onChange={this.searchOnChange}
                onKeyDown={this.onKeyDown}
              />
              <Button onClick={(e) => this.filterCheckEntry(e)}>Filter</Button>
              <Button onClick={(e) => this.resetfilteredCheckEntry(e)}>
                Reset
              </Button>
            </span>
          </div>
          <div className="module_header_secondary_buttons">
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>

        <div className="mt-3">
          <CustomTable
            data={checkEntryList}
            columns={this.postDatedColumns()}
            enableHighlight={true} // Boolean flag controlling highlight execution
            //  searchText={pickTicketCriteria.searchName} // Search input text
          />
        </div>
      </div>
    );
  }
}
class PostDatedCheckEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //

      customerLookupHandler: null,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    // this.setFocus();
  }
  initLookupHandlers = () => {
    //
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer",
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
  };
  render() {
    let checkData = this.props.checkData;

    return (
      <div>
        <Row>
          <Col sm="1">
            <FormLabel>Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent
              name="createdDate"
              value={checkData.createdDate}
              onChange={this.props.onChange}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Customer</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.props.customerOnChange}
              name="customerCode"
              placeholder="Customer"
              value={checkData.customerCode}
              lookupRequired={true}
              lookupHandler={this.state.customerLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.props.customerEnterKeyEventHandler}
              autoCompleteListData={
                this.props.customerPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={
                this.props.displayAutoCustomerCompleteList
              }
              showAutoCompleteList={this.props.isShowAutoCompleteCustomerList}
              disabled={this.props.isDisabledFields}
              isMandatory={true}
            />
          </Col>

          <Col sm="3">
            <InputTextbox
              name="customerName"
              value={checkData.customerName}
              onChange={this.props.onChange}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Invoice</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="invoiceNumber"
              value={checkData.invoiceNumber}
              onChange={this.props.onChange}
              disabled={!this.props.isShowInvoiceLookup}
              lookupRequired={this.props.isShowInvoiceLookup}
              lookupHandler={this.props.openInvoiceLookupHandler}
              showCriteriaDialog={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>CustomerPO#</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="customerPurchaseOrderNumber"
              value={checkData.customerPurchaseOrderNumber}
              onChange={this.props.onChange}
              disabled={this.props.isDisabledFields}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Currency</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="currencyCode"
              value={checkData.currencyCode}
              onChange={this.props.onChange}
              disabled={this.props.isDisabledFields}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Check#</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="checkNumber"
              value={checkData.checkNumber}
              onChange={this.props.onChange}
              isMandatory={true}
              disabled={this.props.isDisabledFields}
            />
          </Col>
          <Col sm="1">
            <FormLabel>CheckDate</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent
              name="checkDate"
              value={checkData.checkDate}
              onChange={this.props.onChange}
              isMandatory={true}
              disabled={this.props.isDisabledFields}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>CheckAmount</FormLabel>
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name="checkAmount"
              value={checkData.checkAmount}
              decimalScale={2}
              onChange={this.props.onChange}
              isMandatory={true}
              disabled={this.props.isDisabledFields}
            />
          </Col>
          <Col sm="1">
            <FormLabel>BankName</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="bankName"
              value={checkData.bankName}
              onChange={this.props.onChange}
              disabled={this.props.isDisabledFields}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Applied Amt</FormLabel>
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name="appliedAmount"
              value={checkData.appliedAmount}
              decimalScale={2}
              onChange={this.props.onChange}
              isMandatory={true}
              disabled={true}
              className="qty_input text-end summary_input"
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel className="label_head">Remarks</FormLabel>
          </Col>
          <Col sm="12">
            <textarea
              rows={3}
              cols={18}
              className="form-control"
              placeholder="Enter Remarks"
              name="remarks"
              value={checkData.remarks}
              onChange={this.props.onChange}
              disabled={this.props.isDisabledFields}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
class PostDatedCheckHistoryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }
  componentDidMount() {
    //
  }
  render() {
    let checkData = this.props.checkData;
    let statusTracks = new Array();
    if (!isEmptyArray(checkData.statusTrackBean)) {
      statusTracks = checkData.statusTrackBean;
    }

    return (
      <div className="header_div">
        <div className="">
          {" "}
          <FormLabel className="label_head">Status History</FormLabel>
          <Table id="fabrics_tables_default">
            <thead>
              <th>Date</th>
              <th>CheckAmount</th>
              <th>Status</th>
              <th>Previous Status</th>
              <th>Done By</th>
              <th>Remarks</th>
            </thead>
            <tbody>
              {statusTracks.map((list, index) => (
                <tr key={index}>
                  <td className="text-start">{list.createdDate}</td>
                  <td className="text-end">{list.checkAmount}</td>

                  <td className="text-start">
                    {ModuleUtils.getPostDatedCheckEntryStatusCaption(
                      list.currentStatus,
                    )}
                  </td>
                  <td className="text-start">
                    {ModuleUtils.getPostDatedCheckEntryStatusCaption(
                      list.previousStatus,
                    )}
                  </td>
                  <td className="text-start">{list.createdBy}</td>
                  <td className="text-start">{list.remarks}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          {statusTracks.length != 0 ? null : (
            <div className="no_Data_small">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
function PostDatedCheckEntryModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <PostDatedCheckEntry {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default PostDatedCheckEntryModule;
